import BaseIcon from '@material-ui/icons/VerifiedUserOutlined';
import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  root: {},
});

export default withStyles(styles)(BaseIcon);
